import { render, staticRenderFns } from "./infoBagde.vue?vue&type=template&id=11b04c94"
import script from "./infoBagde.ts?vue&type=script&lang=js&external"
export * from "./infoBagde.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b04c94')) {
      api.createRecord('11b04c94', component.options)
    } else {
      api.reload('11b04c94', component.options)
    }
    module.hot.accept("./infoBagde.vue?vue&type=template&id=11b04c94", function () {
      api.rerender('11b04c94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/infoBagde/infoBagde.vue"
export default component.exports